import { Contact } from '~api/address_book';

import { Dispatch, PropsWithChildren, SetStateAction, createContext, useContext, useState } from 'react';

import { ContextScopeError } from '~src/errors/ContextScopeError';

interface AddressesContextValue {
  prefix: string;
  contacts: Contact[];
  setContacts: Dispatch<SetStateAction<Contact[]>>;
}

const AddressesContext = createContext<AddressesContextValue>({
  prefix: '',
  contacts: [],
  setContacts: () => null,
});

interface Props extends PropsWithChildren {
  prefix?: string;
  contacts?: Contact[];
}

export function AddressesProvider({ prefix = 'shipment', contacts: initialContacts = [], children }: Props) {
  const [contacts, setContacts] = useState<Contact[]>(initialContacts);

  return <AddressesContext.Provider value={{ prefix, contacts, setContacts }}>{children}</AddressesContext.Provider>;
}

export const useAddresses = () => {
  const context = useContext(AddressesContext);
  if (!context) {
    throw new ContextScopeError('useAddresses', 'AddressesProvider');
  }

  return context;
};
